export const PASSWORD_PATTERN = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#$&*]).{8,}$/;

export const PASSWORD_HINT =
  '8 caractères minimum, une majuscule, une minuscule, un chiffre et un caractère spécial (!@#$&*).';

export const IDENTITY_DOC_OPTIONS: { value: string; label: string }[] = [
  { value: 'passport', label: 'Passeport' },
  { value: 'carte_electeur', label: 'Carte électeur' },
  { value: 'permis_conduire', label: 'Permis de conduire' },
  { value: 'carte_agent_ordre', label: "Carte d'agent d'ordre" },
];

/** Convertit JJ/MM/AAAA → AAAA-MM-JJ pour l'API. */
export function formatBirthDateForApi(displayDate: string): string | null {
  const match = displayDate.trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!match) {
    return null;
  }

  const [, day, month, year] = match;
  return `${year}-${month}-${day}`;
}

/** Affiche une date API (AAAA-MM-JJ) ou déjà formatée en JJ/MM/AAAA. */
export function formatBirthDateForDisplay(raw: string | null | undefined): string {
  const value = (raw ?? '').trim();
  if (!value || value === '-') {
    return '';
  }

  if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
    return value;
  }

  const iso = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) {
    return `${iso[3]}/${iso[2]}/${iso[1]}`;
  }

  return value;
}

export function readFileAsBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      const base64 = result.includes(',') ? result.split(',')[1] : result;
      resolve(base64);
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}

export function getFileExtension(file: File): string {
  const parts = file.name.split('.');
  return parts.length > 1 ? parts.pop()!.toLowerCase() : 'jpg';
}

/** Compresse une image (max 800px, JPEG) et retourne le base64 sans préfixe data-URI. */
export function compressImageToBase64(file: File, maxEdge = 800, quality = 0.8): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let { width, height } = img;
        const scale = Math.min(1, maxEdge / Math.max(width, height));
        width = Math.round(width * scale);
        height = Math.round(height * scale);
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          const result = reader.result as string;
          resolve(result.includes(',') ? result.split(',')[1] : result);
          return;
        }
        ctx.drawImage(img, 0, 0, width, height);
        const dataUrl = canvas.toDataURL('image/jpeg', quality);
        resolve(dataUrl.includes(',') ? dataUrl.split(',')[1] : dataUrl);
      };
      img.onerror = () => reject(new Error('Image invalide'));
      img.src = reader.result as string;
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}
